import React, { useContext } from 'react';
import { Breadcrumb, Grid, Header, Menu } from "semantic-ui-react";
import { Link, NavLink } from 'react-router-dom';
import { ClippedContent, Button } from "dyl-components";

import FavoriteIcon from 'shared/FavoriteIcon';
import { FAVORITE_TYPE } from 'shared/constants/FAVORITE_TYPE';
import TextCampaignModal from 'shared/modals/TextCampaignModal';
import { useDispatch } from 'react-redux';
import campaignContactsActions from 'actions/campaign_contacts';
import { RefreshTextCampaignModal } from 'shared/modals';
import templateCategoryActions from "actions/template_category"
import tcrActions from "actions/tcr"
import campaignActions from 'actions/campaigns'
import { BulkActionsContext } from 'shared/context/BulkActionsProvider';


const CampaignTabsHeader = ({ id, campaign }) => {
    const isDeleted = (campaign.status || '').toLowerCase() === 'deleted';
    const [openModal, setOpenModal] = React.useState(false);

    const [, setSelectedContacts,,setAreAllContactsInAllPagesSelected] = useContext(BulkActionsContext)

    
    const onClose = () => {
        setOpenModal('');
    }

    const onOpen = (type) => {
        setOpenModal(type);
    }
    const dispatch = useDispatch();

    const isActiveCampaign = campaign?.active_session_id;
    const isCurrentSession = isActiveCampaign && campaign.active_session_id === id;
    const isOnlyDialerCampaign = campaign?.is_company_campaign?.campaign_type === null || !campaign?.is_company_campaign?.campaign_type?.includes("text");

    return (
        <Grid columns='equal'>
            <Grid.Row>
                <Grid.Column>
                    <Breadcrumb>
                        <Breadcrumb.Section as={Link} to='/campaigns'>
                            Campaigns
                        </Breadcrumb.Section>
                        <Breadcrumb.Divider />
                        <Breadcrumb.Section>
                            {campaign.name}
                        </Breadcrumb.Section>
                    </Breadcrumb>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column>
                    <Header as='h2'>
                        <FavoriteIcon
                            details={{
                                external_id: Number(id),
                                favorite_type: FAVORITE_TYPE.CAMPAIGN
                            }}
                            doNotRecordRecent
                        />
                        <Header.Content>{campaign.name}</Header.Content>
                        <Header.Subheader><ClippedContent>{campaign.description}</ClippedContent></Header.Subheader>
                    </Header>
                </Grid.Column>
                <Grid.Column>
                    {!isOnlyDialerCampaign &&
                        <>
                            <Button floated='right' primary disabled={isDeleted || isCurrentSession || !campaign?.text_refresh|| !campaign?.total_contact} onClick={() => {
                                onOpen('refresh_text');
                            }}>
                                Refresh Text
                            </Button>
                            <Button floated='right' primary disabled={!campaign?.textable_contacts || isDeleted || isActiveCampaign} onClick={() => {
                                onOpen('text');
                                dispatch(campaignContactsActions.readTextableContacts(id)).then(data => {
                                    setSelectedContacts(data.selected);
                                    setAreAllContactsInAllPagesSelected(true);
                                })
                                dispatch(templateCategoryActions.readCategorizedTemplates({ category: 'text' }));
                                dispatch(tcrActions.getBrand()).then((data) => {
                                    dispatch(tcrActions.getBrandOptOutStatus(data?.brandId))
                                })
                            }}>
                                Send Text
                            </Button>
                        </>
                    }
                    <Button floated='right' primary disabled={true || isDeleted}>
                        Set Up Dialer
                    </Button>
                    <TextCampaignModal 
                        campaign_id={id}
                        onClose={onClose}
                        open={openModal === 'text'}
                        onMessageSend={() => {
                            dispatch(campaignContactsActions.readCampaignContacts(id));
                            dispatch(campaignActions.readCampaign(id));
                            onClose()
                        }}
                    />
                    <RefreshTextCampaignModal 
                        campaign_id={id}
                        onClose={onClose}
                        open={openModal === 'refresh_text'}
                        refresh={()  => {
                            dispatch(campaignContactsActions.readCampaignContacts(id));
                            dispatch(campaignActions.readCampaign(id));
                        }}
                    />
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column>
                    <Menu borderless pointing secondary color='primary' stackable>
                        <Menu.Item as={NavLink} name='Dashboard' to={`/campaigns/${id}/dashboard`} />
                        <Menu.Item as={NavLink} name='Contact List' to={`/campaigns/${id}/contacts`} />
                        {
                            campaign?.is_company_campaign?.start_time &&
                            <Menu.Item as={NavLink} name='User Reports' to={`/campaigns/${id}/user-reports`} />
                        }
                        <Menu.Item as={NavLink} name='Settings' to={`/campaigns/${id}/settings`} />
                        <Menu.Item as={NavLink} name='History' to={`/campaigns/${id}/history`} />
                        <Menu.Item as={NavLink} name='Session Summary' to={`/campaigns/${id}/session-summary/${!isOnlyDialerCampaign ? 'text' : 'dialer'}`} />
                    </Menu>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
}

export default CampaignTabsHeader;
